module.exports = "<div class=\"alain-default__content-title\">\n  <h1>\n    欢迎页\n    <small>Welcome !</small>\n  </h1>\n</div>\n"